import { CustomParseFieldProps } from "@opendash/plugin-parse";
import { Tag } from "antd";
import React from "react";
import ParseQueryForm from "./ParseQueryForm";

const ParseQueryField = (props: CustomParseFieldProps<any>) => {
  if (!props.setValue) return <Tag>Object</Tag>;
  return <ParseQueryForm value={props.value} onChange={props.setValue} />;
};

export default ParseQueryField;
